// src/components/debug/FeatureFlagsDebug.tsx
import { useState } from 'react';
import { useFeatureFlags, useExposureFlags } from '@/hooks/useFeatureFlags';
import { useIsInternalAdmin } from '@/hooks/useIsInternalAdmin';
import { ChevronDown, ChevronUp } from 'lucide-react';

export function FeatureFlagsDebug() {
  const [isExpanded, setIsExpanded] = useState(false);
  const { data: isAdmin } = useIsInternalAdmin();
  const featureFlags = useFeatureFlags();
  const exposureFlags = useExposureFlags();
  
  // Show for internal admins (any env) or in dev mode
  if (!isAdmin && import.meta.env.PROD) {
    return null;
  }

  return (
    // OCT20D-F1: was `bottom-2 right-2`, under the tutorial Help button (Help covered the toggle's corner and the
    // panel's 1344 px² beneath it) and unregistered, so the expanded panel covered page controls ("Vehicle returned —
    // check in"). Now on the rail left of Help (right 80 px = Help's 16 px inset + 56 px + 8 px gap), never wider than
    // the space between Help and the rail's default Report-an-Issue spot (16 + 44 + 8 px on the left: 100vw − 10.5rem),
    // and a registered floating control (the page keeps its band clear; Report an Issue steps around it).
    <div data-floating-control="feature-flags-debug"
      className="fixed bottom-4 right-20 mb-safe-bottom z-50 max-w-[min(20rem,calc(100vw-10.5rem))] rounded bg-muted px-3 py-2 text-xs shadow">
      <button 
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center gap-1 font-semibold w-full justify-between"
      >
        <span>Feature Flags</span>
        {isExpanded ? <ChevronDown className="h-3 w-3" /> : <ChevronUp className="h-3 w-3" />}
      </button>
      {isExpanded && (
        <div className="max-h-64 overflow-y-auto mt-1 space-y-2">
          <div>
            <p className="font-semibold text-[10px] uppercase tracking-wider text-muted-foreground mb-0.5">Entitlement</p>
            <pre className="whitespace-pre-wrap text-[10px]">
              {JSON.stringify(featureFlags, null, 2)}
            </pre>
          </div>
          <div>
            <p className="font-semibold text-[10px] uppercase tracking-wider text-muted-foreground mb-0.5">Exposure (UI)</p>
            <pre className="whitespace-pre-wrap text-[10px]">
              {JSON.stringify(exposureFlags, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
}
